import { EMPLOYMENT_TYPE_TRAINEE } from "model/OrganizationalStructure";
import { SalaryType } from "model/Salary";
import type { AddStaffFormData } from "./addStaffPanel.contract";
import { createInitialFormData } from "./addStaffPanel.mapper";
import type { StampClockRegistrationFormData } from "./stampClockRegistration.contract";

export const STAMP_CLOCK_REGISTRATION_ROLE = "Medarbetare";

export const toStampClockRegistrationAddStaffFormData = ({
  employeeNumber,
  formData,
  teamId,
}: {
  readonly employeeNumber: string;
  readonly formData: StampClockRegistrationFormData;
  readonly teamId: string;
}): AddStaffFormData => ({
  ...createInitialFormData(),
  employeeNumber,
  employmentType: EMPLOYMENT_TYPE_TRAINEE,
  firstName: formData.firstName,
  lastName: formData.lastName,
  personalIdentityNumber: formData.personalIdentityNumber,
  phoneNumber: formData.phoneNumber,
  role: STAMP_CLOCK_REGISTRATION_ROLE,
  salaryType: SalaryType.Hourly,
  teamIds: [teamId],
});
